import script from "./icon-two-tones-tag-user.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-two-tones-tag-user.vue?vue&type=script&lang=ts&setup=true"

import "./icon-two-tones-tag-user.vue?vue&type=style&index=0&id=78e0a609&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78e0a609"]])

export default __exports__